import React from 'react'
import { view } from 'react-easy-state'
import { withRouter } from 'react-router-dom'
import { Button, Row, Col } from 'antd'

import globalStore from 'store'
class QuestionnaireView extends React.Component {

  startQuestionnaire = (questionType) => {
    const { chapterId, questionnaireId } = this.props.match.params
    this.props.history.push(`/chapters/${chapterId}/questionnaires/${questionnaireId}/start-${questionType}`)
  }

  render() {

    const { questionnaire, questionnaire_attempt } = globalStore.ui.students.questionnaires.show

    console.log('questionnaire', questionnaire)
    console.log('questionnaire_attempt', questionnaire_attempt)

    const { 
      total_objective_questions_count,
      total_subjective_questions_count,
      attempted_objective_questions_count,
      attempted_subjective_questions_count,
    } = questionnaire_attempt

    const objectiveQuestionDisabled = ((total_objective_questions_count === 0) || (total_objective_questions_count === attempted_objective_questions_count)) ? true : false
    const subjectiveQuestionDisabled = ((total_subjective_questions_count === 0) || (total_subjective_questions_count === attempted_subjective_questions_count)) ? true : false

    return (
      <React.Fragment>
        <h1>{questionnaire.name}</h1>
        <div>{questionnaire.instructions}</div>
        {questionnaire.duration ? <div><strong>Duration:</strong> {questionnaire.duration} Minutes</div> : null}
        {questionnaire.num_questions ? <div><strong>Total Questions:</strong> {questionnaire.num_questions}</div> : null}
        {questionnaire.positive_marks ? <div><strong>Positive Marks:</strong> {questionnaire.positive_marks}</div> : null}
        {questionnaire.negative_marks ? <div><strong>Negative Marks:</strong> {questionnaire.negative_marks}</div> : null}
        
        <Row gutter={40} style={{ marginTop: 50 }}>
          <Col>
            <div style={{ textAlign: 'center' }}>
              <Button 
                type="primary" 
                disabled={objectiveQuestionDisabled}
                style={{ marginTop: 30, height: 50 }} 
                onClick={() => this.startQuestionnaire('objective')}>Practice Objective Questions</Button>
            </div>
          </Col>
          <Col>
            <div style={{ textAlign: 'center' }}>
              <Button 
                type="primary"
                disabled={subjectiveQuestionDisabled} 
                style={{ marginTop: 30, height: 50 }} 
                onClick={() => this.startQuestionnaire('subjective')}>Practice Subjective Questions</Button>
            </div>
          </Col>
        </Row>
        {/* {
          <Button type="primary" style={{ marginTop: 30 }} onClick={this.startQuestionnaire}>Start</Button>
        } */}
      </React.Fragment>
    )

  }
}

export default withRouter(view(QuestionnaireView))
